import ApplicationInfoPage from '@/features/applications/[applicationId]/application-info/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info',
)({
  component: ApplicationInfoPage,
})
